define('core/views/media/UploadButtonView',[
    'jquery',
    'underscore',
    'backbone',

    'core/templates/postMediaUploadButton',
    'core/utils',
], function (
    $,
    _,
    Backbone,

    uploadButtonTemplate,
    utils
) {
    'use strict';

    var handler = utils.stopEventHandler;

    // TODO: Simplify selector
    var inputSelector = 'input[type=file][data-role=media-upload]';

    // Upload button
    // Uses a hidden input element to open a browse dialog
    var UploadButtonView = Backbone.View.extend({
        events: (function () {
            var events = {
                'click [data-action=attach]': '_attachMedia',
            };
            events['change ' + inputSelector] = '_selectorChange';
            return events;
        }()),

        initialize: function (options) {
            this.template = options && options.template || this.generateImageUploadButton;
        },

        generateImageUploadButton: function () {
            return uploadButtonTemplate({
                imageUrl: 'https://c.disquscdn.com/next/embed/assets/img/attach.03c320b14aa9c071da30c904d0a0827f.svg',
            });
        },

        render: function () {
            this.$el.html(this.template());

            return this;
        },

        _attachMedia: _.throttle(handler(function () {
            this.$(inputSelector).click();
        }), 5000, { trailing: false }),  // throttle double modal for uploading image by 5s

        _selectorChange: function (evt) {
            var input = evt.target;
            var files = input.files;

            if (!files.length)
                return;

            this.trigger('uploader:attachMedia', files);

            // Clear file input by replacing with a clone
            $(input).replaceWith(input.cloneNode());
        },
    });

    return UploadButtonView;
});

